import { render, staticRenderFns } from "./ScormPayloadInfo.vue?vue&type=template&id=43b3f2f8&scoped=true"
import script from "./ScormPayloadInfo.vue?vue&type=script&lang=js"
export * from "./ScormPayloadInfo.vue?vue&type=script&lang=js"
import style0 from "./ScormPayloadInfo.vue?vue&type=style&index=0&id=43b3f2f8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b3f2f8",
  null
  
)

export default component.exports